import { toast } from '@liveauctioneers/hammer-ui-core/toast';
import { useCallback } from 'react';

import { useAppDispatch } from '@/redux/hooks';
import { type SaveSearchParamsOrKey, SaveSearchResult, submitSaveSearch } from '@/redux/modules/saveSearch';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

/**
 * Follows a search and tells the bidder when savedsearch-api refused it for invalid facet values,
 * which otherwise fails silently: the follow button just stays unfollowed.
 */
export const useSubmitSaveSearch = () => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();

    return useCallback(
        async (saveSearchParams: SaveSearchParamsOrKey, sendAlert: boolean) => {
            const result = await dispatch(submitSaveSearch(saveSearchParams, sendAlert));
            if (result === SaveSearchResult.InvalidFacets) {
                toast('error', {
                    description: formatMessage(['toastMessages', 'descriptions', 'searchNotSavedInvalidFilters']),
                    title: String(formatMessage(['toastMessages', 'titles', 'searchNotSaved'])),
                });
            }
            return result;
        },
        [dispatch, formatMessage]
    );
};
